'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var ZhenzhouGongMei = function (_Component) {
  (0, _inherits3.default)(ZhenzhouGongMei, _Component);

  function ZhenzhouGongMei() {
    (0, _classCallCheck3.default)(this, ZhenzhouGongMei);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ZhenzhouGongMei).call(this));

    _this.state = {
      isContentShow: true
    };
    return _this;
  }

  (0, _createClass3.default)(ZhenzhouGongMei, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'onJianJieChangeBtnClick',
    value: function onJianJieChangeBtnClick() {
      this.setState({
        isContentShow: true
      });
    }
  }, {
    key: 'onDizhiChangeBtnClick',
    value: function onDizhiChangeBtnClick() {
      this.setState({
        isContentShow: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ZhenzhouGongMei.scss');
      var isContentShow = this.state.isContentShow;

      var jianjieStyle = styles.New_profile;
      var dizhiStyle = styles.New_profile + ' ' + styles.New_profile_address + ' ' + styles.miss;
      if (isContentShow) {
        jianjieStyle = styles.New_profile;
        dizhiStyle = styles.New_profile + ' ' + styles.New_profile_address + ' ' + styles.miss;
      } else {
        jianjieStyle = styles.New_profile + ' ' + styles.miss;
        dizhiStyle = styles.New_profile + ' ' + styles.New_profile_address;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.New_zhengzhou_box + ' ' + styles.New_bg_01, style: { minWidth: '1280px' } },
        _react2.default.createElement(
          'div',
          { className: styles.New_logo_top },
          _react2.default.createElement(
            'a',
            { href: '/' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/icon_logo_01.png', alt: '',
              className: styles.New_logo })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.New_wap_bottom },
          _react2.default.createElement(
            'div',
            { className: styles.New_wap_left },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_img_03.png', alt: '',
              className: styles.New_build }),
            _react2.default.createElement(
              'a',
              { href: '/workstationshoplist/M0045080000000000000000008',
                className: styles.New_scale + ' ' + styles.ComeIn },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_button_03.png',
                alt: '' })
            ),
            _react2.default.createElement(
              'a',
              { className: styles.New_logo_title_one },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_title_02.png', alt: '' })
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.New_button_ul },
              _react2.default.createElement(
                'li',
                { onClick: this.onJianJieChangeBtnClick.bind(this) },
                _react2.default.createElement('img', {
                  src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_button_01.png', alt: '' })
              ),
              _react2.default.createElement(
                'li',
                { onClick: this.onDizhiChangeBtnClick.bind(this) },
                _react2.default.createElement('img', {
                  src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_button_02.png', alt: '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: jianjieStyle, id: 'Profile' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/icon_jianjie_03.png', alt: '' }),
              _react2.default.createElement(
                'h4',
                null,
                '郑州古玩城简介'
              ),
              _react2.default.createElement(
                'p',
                null,
                '郑州古玩城始建于1997年，1998年2月正式开业。古玩城位于郑州市大学中路淮河路交叉口，共为四层大型商场，包括了古玩、工艺美术品、收藏品等多品种经营项目。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '拥有商户500余家，从业人员千余人，资产1.4亿元，拥有20000平方米的交易场地及附属设施，是国内最大的古玩市场之一，也是经河南省文物局批准的河南省唯一一个文物监管物品经营市场，严格守法，诚信经营，不仅在国内外同行及顾客中赢得良好的商誉，而且也为古玩城自身创造了巨大的经济效益和社会效益，使其成为全国古玩商会的主力成员。'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: dizhiStyle, id: 'Address' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/icon_jianjie_05.png', alt: '' }),
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/img_map_04.png', alt: '',
                className: styles.New_map }),
              _react2.default.createElement(
                'h3',
                null,
                '0371-61992666'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.New_wap_right },
            _react2.default.createElement(
              'a',
              { href: '/workstationlist?workstationType=0' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/new_zhengzhou/icon_jiantou_02.png',
                alt: '' })
            )
          )
        )
      );
    }
  }]);
  return ZhenzhouGongMei;
}(_react.Component); /**
                      * Created by zfc on 2017/8/19.
                      */

exports.default = ZhenzhouGongMei;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ZhenzhouGongMei/ZhenzhouGongMei.js
 ** module id = 1556
 ** module chunks = 0
 **/